"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyRowSourcesGetAll = void 0;
exports.rowSourcesGetAllSetMock = rowSourcesGetAllSetMock;
exports.rowSourcesGetAll = rowSourcesGetAll;
exports.useQueryRowSourcesGetAll = useQueryRowSourcesGetAll;
exports.useInfiniteQueryRowSourcesGetAll = useInfiniteQueryRowSourcesGetAll;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function rowSourcesGetAllSetMock(mock) {
    setMock = mock;
}
async function rowSourcesGetAll(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v1/rows/sources`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.sortAsc = params.sortAsc;
    queryParams.sortDesc = params.sortDesc;
    queryParams.page = params.page;
    queryParams.perPage = params.perPage;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyRowSourcesGetAll = 'wolf-athenaeum-service:rowSourcesGetAll:get';
function useQueryRowSourcesGetAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyRowSourcesGetAll, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryRowSourcesGetAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyRowSourcesGetAll, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = rowSourcesGetAll(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=row-sources-get-all.js.map